import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const dataModelRoutes: RouteRecordRaw[] = [
  {
    path: '/data-models',
    name: RouteNames.DataModels,
    component: () => import('@/views/data-model/ListDataModels.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/data-models/deprecated',
    name: RouteNames.DeprecatedDataModels,
    component: () => import('@/views/deprecated/AllDataModelsView.vue'),
  },
  {
    path: '/namespaces/:namespaceId/data-models',
    children: [
      {
        path: '',
        redirect: (to) => ({
          name: RouteNames.NamespaceTemplate,
          params: {
            namespaceId: to.params.namespaceId,
          },
          query: {
            view: 'datamodels',
          },
        }),
      },
      {
        path: ':dataModelId',
        name: RouteNames.DataModel,
        component: () => import('@/views/DataModelView.vue'),
      },
    ],
  },
];

export default dataModelRoutes;
